import React from 'react';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="bg-brand-gray px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="pain-heading" data-id="element-102" data-mp="38xoher0tacsw">
      <h2 id="pain-heading" className="mb-1.5 text-center text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-103" data-mp="2uyfe2rxpfd6c">
        Ti Ritrovi in Una di Queste Situazioni?
      </h2>
      <p className="mb-1 text-center text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-104" data-mp="2l82j05s9k1ly">
        Ami insegnare il padel e aiutare i tuoi giocatori a migliorare. Ma preparare lezioni complete
        e professionali richiede sempre più tempo.
      </p>
      <p className="mb-2.5 text-center text-[12px] font-bold leading-snug text-brand-navy sm:text-sm" data-id="element-105" data-mp="2g995idcz8als">
        Se lavori ogni settimana con giocatori individuali, coppie o gruppi di livelli differenti,
        probabilmente conosci molto bene queste situazioni.
      </p>
      <div className="space-y-1.5" data-id="element-106" data-mp="277rrd0j4qizq">
        {pains.map(pain => <article key={pain.title} className="flex gap-2.5 rounded-lg border-l-4 border-brand-green bg-white p-2.5 shadow-sm sm:p-3" data-id="element-107" data-mp="3rlzizgf1e7pg">
            <span className="text-lg leading-none" aria-hidden="true" data-id="element-108" data-mp="5fkfb0o7y04p">
              {pain.emoji}
            </span>
            <div data-id="element-109" data-mp="gg8uhsoigi2">
              <h3 className="mb-0.5 text-[13px] font-extrabold leading-tight text-brand-navy sm:text-base" data-id="element-110" data-mp="i10nznlzlc8">
                {pain.title}
              </h3>
              <p className="text-[11.5px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-111" data-mp="33xq0and4e02j">
                {pain.text}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}